<template>
  <div class="down_load">
    <div class="down_load_left">
      <img class="down_load_logo" :src="downLoad.icon" />
      <div class="down_load_text">
        <h2>{{downLoad.title}}</h2>
        <p>官方移动发布平台</p>
      </div>
    </div>
    <div @click="handleDownLoad" class="down_load_btn">下载</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      downLoad: {},
      orgid: orgid
    };
  },
  methods: {
    handleDownLoad() {
      window.location.href =
        "https://app.iqilu.com/download/jump?orgid=" + this.orgid;
    },
    /**
     * 获取下载信息
     */
    getDownLoad() {
      this.$jsonp(
        `${this.baseConfig.apiRoot}/v1/govnum/app/index/getAppInfo?_orgid_=${this.orgid}`,
        {
          callbackQuery: "cqcallback"
        }
      ).then(res => {
        this.downLoad = res.data;
      })
    }
  },
  mounted() {
    this.getDownLoad();
  }
};
</script>

<style scoped>
.down_load {
  position: fixed;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.3rem;
  width: 100%;
  height: 1.18rem;
  background-color: #fff;
}
.down_load_logo {
  width: 0.88rem;
  height: 0.88rem;
  border-radius: 0.2rem;
  margin-right: 0.2rem;
}
.down_load_left {
  display: flex;
  align-items: center;
}
.down_load_text h2 {
  font-size: 0.32rem;
  color: #333;
  font-weight: "500";
}
.down_load_text p {
  font-size: 0.24rem;
  color: #8f8f8f;
  margin-top: 0.1rem;
}
.down_load_btn {
  display: inline-block;
  text-align: center;
  line-height: 0.6rem;
  min-width: 1rem;
  height: 0.6rem;
  font-size: 0.28rem;
  color: #fff;
  background-color: #46a1f6;
  border-radius: 0.3rem;
}
</style>
